'use client';
import { ReactNode } from 'react';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '@/redux/slice/authSlice';
import { RootState } from '@/redux/store';
import { getSessionStorageItem } from '@/lib/storage';
import Loader from './loader/Loader';
import NormalHeader from '@/components/NormalHeader/NormalHeader';

interface ProtectedRouteProps {
  children: ReactNode; // Define children as a ReactNode prop
}

const UnProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const isAuthenticated = getSessionStorageItem('token');
  const { loading } = useSelector((state: RootState) => state.auth);

  const { push } = useRouter();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLoading(true));
    const isAuthenticated = getSessionStorageItem('token');
    if (isAuthenticated === null || isAuthenticated === undefined || isAuthenticated === '') {
      dispatch(setLoading(false));
    } else {
      push('/home');
    }
  }, [isAuthenticated, push]);

  if (loading) {
    return (
      <div className="  h-full min-w-full flex justify-center items-center">
        <Loader />
      </div>
    );
  }

  // Render children if authenticated
  return (
    <>
      <NormalHeader />
      {children}
    </>
  );
};

export default UnProtectedRoute;
